module.exports = __webpack_public_path__ + "media/images/icon/icon_f1-14256796779a8082ff69823c1847a215.png";